import * as React from 'react';
import type { InjectedRouter } from 'react-router';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';

import Retracked from 'js/app/retracked';
import connectToStores from 'js/lib/connectToStores';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/reviews/styl/index';

type Props = {
  requestCountryCode?: string;
  csrfToken?: string;
  children?: JSX.Element;
};

type Context = {
  router: InjectedRouter;
  getStore: (storeName: string) => any;
};

class ReviewsApp extends React.Component<Props> {
  static propTypes = {
    requestCountryCode: PropTypes.string,
    csrfToken: PropTypes.string,
    children: PropTypes.node,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof ReviewsApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  constructor(props: Props, context: Context) {
    super(props);
  }

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;
    return { csrfToken, requestCountryCode };
  }

  render() {
    const { children } = this.props;
    return (
      <div className="rc-ReviewsApp">
        <PageHeader showLanguagesDropdown />
        {children}
        <PageFooter />
      </div>
    );
  }
}

export default compose(
  // TODO: connectToStores<Props, InputProps, Stores>
  connectToStores<any, any>([ApplicationStoreClass], (ApplicationStore, props) => ({
    ...props,
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  })),
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'reviews',
      page: 'reviews',
    },
  }))
  // @ts-expect-error TSMIGRATION
)(ReviewsApp);
